import _ from "lodash";

export const getFieldValues = (data, metaData) => {
    let result = [];
    if (Array.isArray(data)) {
        data.forEach((name) => {
            const f = _.find(metaData, { name });
            if (f) {
                result = _.concat(result, f.values);
            }
        });
    } else {
        let f = _.find(metaData, { name: data });
        if (f) {
            result = _.concat(result, f.values);
        }
    }
    return result;
};
